'use client'
import { getTranslations } from '@/lib/next-shim'
import { objectTypes } from '@/core/api/modules/document'
import { PageTitle } from '@/shared/ui/seo/PageTitle'

import { useDocumentsPage } from '../model/useDocumentsPage'
import { DocumentsList } from './DocumentsList'

export function DocumentsPage() {
  const t = getTranslations('page.AccountDocuments')
  const tCommon = getTranslations('common')

  const { loading, patientId, patientFiles, consultationFiles } = useDocumentsPage()

  if (loading) return <div className="p-10 text-center">{tCommon('loading')}</div>

  return (
    <div className="flex flex-1 flex-col gap-10 pt-6">
      <PageTitle title={t('title')} />
      <h1 className="sr-only">{t('title')}</h1>
      <DocumentsList patientFiles={patientFiles} consultationFiles={consultationFiles} patientId={patientId} objectType={objectTypes[1]} />
    </div>
  )
}
